<template>

</template>

<script>
    export default {
        name: 'csLazy',
        data() {
            return {}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/lazy/src/lazy.vue